<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="validateFoodAndHideModal(food)" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">Edytuj danie: {{food.name}}</h4>
        </div>
        <div class="modal-body">
            <food-edit
                :food="food"
                :plan="plan"
                :day="day"
                :product-replaced="productReplaced"
                ref="foodEdit"></food-edit>
        </div>
        <div class="modal-footer">
            <slot name="prevModal"></slot>
            <permission-tooltip
                :permission="canCreateFood()"
                :tooltip="{top: false, bottom: true, attach: false}"
            >
                <loading-button :disabled="!canCreateFood()" :loading="isLoading" :status="status" @click="storeOrUpdate">
                    <i class="fa fa-save"></i>
                    Zapisz do mojej bazy
                </loading-button>
            </permission-tooltip>

            <button class="btn btn-success pull-right" :style="{'margin-left': '5px'}" @click="validateFoodAndHideModal(food)">Gotowe</button>
        </div>
    </div>
</template>

<style scoped>
    .in {
        display: block;
    }

    .products-table {
        font-size: 13px;
    }
</style>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import {productFactory} from '../../../factory/product.factory';
    import {multiPortionFoodsManager} from "../../../services/MultiPortionFoodsManager";
    import {trans} from "../../../app";
    import {FoodService} from "../../../services/FoodService";
import {DIETITIAN_FREE, DIETITIAN_TEST} from "../../../utils/roles";

    export default {
        data() {
            return {
                food: null,
                day: null,
                plan: null,
                productReplaced: false,
                isLoading: false,
                status: '',
            };
        },
        async created() {
          await this.fetchOwnFoodsCount();
        },
        computed: {
            ...mapState({
                modalData: state => state.modal.data,
                schema: state => state.menu.schema,
            }),
            ...mapGetters([
                'getDayById',
                'configuration',
                'getPlanById',
                'userRole',
                'ownFoodsCount',
            ])
        },
        methods: {
            ...mapActions([
                'fetchOwnFoodsCount',
            ]),
            ...mapMutations([
                'hideModal',
                'addMeal',
                'removeFoodWithReplacement',
            ]),
            getFood(dayId, planId, foodId) {
              return this.getPlanById(dayId, planId).getFood(foodId);
            },
            remove(productId) {
                this.food.removeProduct(productId);
            },
            addProduct(product) {
                this.food.addProduct(productFactory.createFromDto(product));
            },
            validateFoodAndHideModal(food) {
                this.$refs.foodEdit.validateFood();
                if (food.isValid()) {
                    this.hideModal();
                }
            },
            async storeOrUpdate(update = false) {
                this.$refs.foodEdit.validateFood();
                if (!this.food.isValid()) {
                    return;
                }

                this.isLoading = true;
                try {
                    let portions;
                    if (this.food.isMultiPortionFood()) {
                        portions = multiPortionFoodsManager.getPortionsOfFood(this.food, this.schema, true)
                            .map(portion => {
                                return portion.food;
                            }).filter(portionFood => {
                                return portionFood.id !== this.id;
                            });
                    }

                    if (update) {
                      this.food = await FoodService.updateFood(this.food);
                    } else {
                      this.food = await FoodService.storeFood(this.food);
                    }

                    await this.fetchOwnFoodsCount();

                    if (this.food.isMultiPortionFood()) {
                        portions.forEach(portionFood => {
                            portionFood.externalId = this.food.externalId;
                        });
                    }

                    this.status = true;
                    this.$toast.success(trans('app.food_saved'));
                } catch (error) {
                    this.status = false;
                    if (error.response && error.response.status === 409) {
                        if (error.response.data.food_uuids.length === 1) {
                          this.$confirmWarning(trans('app.food_already_exists_in_database_update')).then(() => {
                            this.food.externalId = error.response.data.food_uuids[0];
                            this.storeOrUpdate(true)
                          }).catch((error) => {
                            this.sentryCaptureException(error);
                            this.status = '';
                          })
                        } else {
                          this.$toast(trans('app.food_already_exists_in_database'));
                        }
                    } else {
                        this.$toast.error(trans('app.food_not_saved'));
                        this.sentryCaptureException(error);
                    }
                }

                this.isLoading = false;
            },
            canCreateFood() {
                if (this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) {
                    return this.ownFoodsCount < 20;
                }
                return true;
            },
        },
        watch: {
            modalData: {
                immediate: true,
                handler: function (data) {
                    if (!data) return;
                    this.day = this.getDayById(data.dayId);
                    this.plan = this.day.getPlan(data.planId);
                    this.food = this.plan.getFood(data.foodId);
                    this.removeFoodWithReplacement(this.food);
                    this.productReplaced = data.productReplaced;
                },
            },
        },
    };
</script>
